export const SET_AUTH_MESSAGE = 'APP_SET_AUTH_MESSAGE';

export interface SetAuthMessageAction {
  type: typeof SET_AUTH_MESSAGE;
  message: string | null;
}

export function setAuthMessage(message: string | null): SetAuthMessageAction {
  return {
    type: SET_AUTH_MESSAGE,
    message,
  };
}
